{
  "alert": "Сигнал тривоги",
  "dismiss": "Скасувати"
}
